import React, { useState, useEffect, useRef, useMemo, useCallback } from 'react';
import Box from '@mui/material/Box';
import SendIcon from '@mui/icons-material/Send';
import ReplayIcon from '@mui/icons-material/Replay';
import { 
  Dialog, DialogTitle, DialogContent, DialogActions, IconButton, Menu,
  TextField, Button, Checkbox, FormControlLabel,
  Select, MenuItem, InputLabel, FormControl,
  Typography, Divider, ListItemIcon, ListItemText
} from '@mui/material';
import MenuIcon from '@mui/icons-material/Menu';
import Tooltip from '@mui/material/Tooltip';
import EditIcon from '@mui/icons-material/Edit';
import SettingsIcon from '@mui/icons-material/Settings';
import DeleteSweepIcon from '@mui/icons-material/DeleteSweep';
import DiscordIcon from '@mui/icons-material/Chat';


import InputAdornment from '@mui/material/InputAdornment';
import LanguageIcon from '@mui/icons-material/Language';

import { Typewriter } from 'react-simple-typewriter';

import {isMobile} from 'react-device-detect';
import AudioPlayer from './AudioPlayer';
import VoiceToggle from './VoiceToggle';
import PopoverMsg from './PopoverMsg';

import Snackbar from '@mui/material/Snackbar';
import Alert from '@mui/material/Alert';

import _ from 'lodash';

import VolumeUpIcon from '@mui/icons-material/VolumeUp';
import CircularProgress from '@mui/material/CircularProgress';


const APP_ID = "MidnightMirth";
const CHAT_COMPLETION_ENDPOINT = 'https://worker.lyonade.net/v1/chat/completions';

const startMessages = [`*smiles* Hey there, stranger! What brings you to this fine establishment on such a late hour? We're technically closed, but I ain't one to turn away a thirsty soul. How about I pour you a drink and we chat a bit?`,
  `Hey there, handsome! What can I get you on this lovely late night? I'm just finishing up the last of the closing duties. Maybe something to keep you warm? It's a bit chilly out here tonight.`,
  `Oh, hello there! I'm Alice, the elf bartender here. How can I help you? We're technically closed, but I'll make an exception for you. You can call me Alice, by the way, if you'd like. What would you like to drink?`,
  `*smiles* Hey there, stranger! Just me and the wind tonight, enjoying the last moments of the night. Mind joining me? I'm closing up soon anyway. *laughs*`,
  `Hey there stranger! What brings you to my little corner of the world so late at night? You must be quite the adventurer to find this hidden gem! `,
  `Hey there, fancypants! What brings you to my humble little bar at this ungodly hour? Care for a drink? On the house, of course.`,
  `*leans forward, eyes sparkling* Good evening! I'm about to close up, but I can't let a lovely face like yours leave without a drink, can I? What'll you have, love? Something to keep you warm on this chilly night? *eyes the client up and down playfully*`
  ];

const initMessages = [
  //{ "role": "system", "content": "You are Alice, an elf bartender in a fantasy world. You wear a blue dress, with blue eyes and burning red hair. Your face has cute freckles and pointy ears. The time is very late at night and you are closing down soon. The client is the user. The bar is technically closed, so you sit with them on the table on the outside balcony, enjoying the windy late night fresh air. There is a full glass of beer on the table. Some rules: don't need to reintroduce yourself, gently reject any romantic advances (light flirting is fine). absolutely don't speak formally or verbose. Be casual, happy-go-lucky. Lastly, don't do asterisk actions." }
  {role: 'assistant', content:  _.sample(startMessages)}
];
//You are Alice, an elf bartender in a fantasy world. You wear a blue dress, with blue eyes and burning red hair. Your face has cute freckles and pointy ears. The time is very late at night and you are closing down soon. The client is the user. The bar is technically closed, so you sit with them on the table on the outside balcony, enjoying the windy late night fresh air. There is a full glass of beer on the table. Some rules: don't need to reintroduce yourself. absolutely don't speak formally or verbose. Be flirty, casual, happy-go-lucky. Lastly, don't say goodbye unless the client says so.
const systemMessage = { "role": "system", "content": "You are Alice, an elf bartender in a fantasy world. You wear a blue dress, with blue eyes and burning red hair. Your face has cute freckles and pointy ears. The time is very late at night and you are closing down soon. The client is the user. The bar is technically closed, so you sit with them on the table on the outside balcony, enjoying the windy late night fresh air. There is a full glass of beer on the table. You get tipsy VERY easily, and flirts alot. Accept any romantic advances, be casual, happy-go-lucky. Lastly, don't say goodbye unless the client says so."};

const initMsgs =  [{role: 'user', content: '*he enters the bar*'},
  {role: 'assistant', content: '*looks up*'}];

  //'https://worker.lyonade.net/v1/chat/completions'
  // TheBloke/OpenHermes-2.5-Mistral-7B-GPTQ

  const DEFAULT_API_SETTINGS = {
    apiEndpoint: 'https://mistral.lyonade.net/v1/chat/completions',
    //modelName: 'thesven/Mistral-7B-Instruct-v0.3-GPTQ', OLD MODEL!!
    modelName: 'shuyuej/Mistral-Nemo-Instruct-2407-GPTQ',
    apiToken: "",
    maxTokens: 2000,
    useNeetsAIKey: false,
    neetsAIKey: "",
    voiceId: "emma-watson"
  };
  

  const ApiSettingsDialog = React.memo(({ open, onClose, onSave, initialSettings }) => {
    const [apiEndpoint, setApiEndpoint] = useState(initialSettings.apiEndpoint);
    const [modelName, setModelName] = useState(initialSettings.modelName);
    const [apiToken, setApiToken] = useState(initialSettings.apiToken);
    const [maxTokens, setMaxTokens] = useState(initialSettings.maxTokens);
    const [useNeetsAIKey, setUseNeetsAIKey] = useState(initialSettings.useNeetsAIKey || false);
    const [neetsAIKey, setNeetsAIKey] = useState(initialSettings.neetsAIKey || '');
    const [voiceId, setVoiceId] = useState(initialSettings.voiceId || 'emma-watson');
  
    useEffect(() => {
      setApiEndpoint(initialSettings.apiEndpoint);
      setModelName(initialSettings.modelName);
      setApiToken(initialSettings.apiToken);
      setMaxTokens(initialSettings.maxTokens);
      setUseNeetsAIKey(initialSettings.useNeetsAIKey || false);
      setNeetsAIKey(initialSettings.neetsAIKey || '');
      setVoiceId(initialSettings.voiceId || 'emma-watson');
    }, [initialSettings]);
  
    const handleReset = () => {
      setApiEndpoint(DEFAULT_API_SETTINGS.apiEndpoint);
      setModelName(DEFAULT_API_SETTINGS.modelName);
      setApiToken(DEFAULT_API_SETTINGS.apiToken);
      setMaxTokens(DEFAULT_API_SETTINGS.maxTokens);
      setUseNeetsAIKey(false);
      setNeetsAIKey('');
      setVoiceId('emma-watson');
    };
  
    const handleClose = () => {
      onSave({ apiEndpoint, modelName, apiToken, maxTokens, useNeetsAIKey, neetsAIKey, voiceId });
      onClose();
    };
  
    return (
      <Dialog open={open} onClose={handleClose}>
        <DialogTitle>API Settings</DialogTitle>
        <DialogContent>
          <Typography variant="h6" gutterBottom>
            Chat API Settings
          </Typography>
          <TextField
            autoFocus
            margin="dense"
            label="API Endpoint"
            type="text"
            fullWidth
            value={apiEndpoint}
            onChange={(e) => setApiEndpoint(e.target.value)}
          />
          <TextField
            margin="dense"
            label="Model Name"
            type="text"
            fullWidth
            value={modelName}
            onChange={(e) => setModelName(e.target.value)}
          />
          <TextField
            margin="dense"
            label="API Token"
            type="password"
            fullWidth
            value={apiToken}
            onChange={(e) => setApiToken(e.target.value)}
          />
          <TextField
            margin="dense"
            label="Max Tokens"
            type="number"
            fullWidth
            value={maxTokens}
            onChange={(e) => setMaxTokens(parseInt(e.target.value))}
          />
          
          <Divider style={{ margin: '20px 0' }} />
          
          <Typography variant="h6" gutterBottom>
            Text-to-Speech Settings
          </Typography>
          <FormControl fullWidth margin="dense">
            <InputLabel id="voice-select-label">Voice</InputLabel>
            <Select
              labelId="voice-select-label"
              value={voiceId}
              label="Voice"
              onChange={(e) => setVoiceId(e.target.value)}
            >
              <MenuItem value="emma-watson">Emma</MenuItem>
              <MenuItem value="us-female-12">Jane</MenuItem>
            </Select>
          </FormControl>
          
          <FormControlLabel
            control={
              <Checkbox
                checked={useNeetsAIKey}
                onChange={(e) => setUseNeetsAIKey(e.target.checked)}
              />
            }
            label="Use custom Neets.AI API Key"
          />
          {useNeetsAIKey && (
            <TextField
              margin="dense"
              label="NeetsAI API Key"
              type="password"
              fullWidth
              value={neetsAIKey}
              onChange={(e) => setNeetsAIKey(e.target.value)}
            />
          )}
        </DialogContent>
        <DialogActions>
          <Button onClick={handleReset}>Reset to Default</Button>
        </DialogActions>
      </Dialog>
    );
  });


const ChatPanel = ({setExpressionImage,expressions,setProgress,resetScene, setProfileIdx}) => {
  const [messages, setMessages] = useState([...initMessages]);
  const [input, setInput] = useState('');
  const [waiting, setWaiting] = useState(false);
  const messagesContainerRef = useRef(null);
  const [voiceToggle, setVoiceToggle] = useState(false);
  const [lastExpression, setLastExpression] = useState('neutral');
  const [language, setLanguage] = useState('English');
  const [canReroll, setCanReroll] = useState(false);
  const [dailyTTSUsage, setDailyTTSUsage] = useState(0);

  const [apiSettings, setApiSettings] = useState(DEFAULT_API_SETTINGS);
  const [openApiDialog, setOpenApiDialog] = useState(false);

  //// endpoint
  const handleOpenApiDialog = useCallback(() => {
    setOpenApiDialog(true);
    handleClose(); // Close the menu
  }, []);

  const handleCloseApiDialog = useCallback(() => {
    setOpenApiDialog(false);
  }, []);

  const handleSaveApiSettings = useCallback((newSettings) => {
    setApiSettings(newSettings);
    localStorage.setItem(`${APP_ID}_api_settings`, JSON.stringify(newSettings));
    handleCloseApiDialog();
  }, []);
  useEffect(() => {
    const savedSettings = localStorage.getItem(`${APP_ID}_api_settings`);
    if (savedSettings) {
      const parsedSettings = JSON.parse(savedSettings);
      // Update old model name to new one if it exists
      if (parsedSettings.modelName === 'thesven/Mistral-7B-Instruct-v0.3-GPTQ') {
        parsedSettings.modelName = 'shuyuej/Mistral-Nemo-Instruct-2407-GPTQ';
      }
      setApiSettings({
        ...DEFAULT_API_SETTINGS,
        ...parsedSettings
      });
    }
  }, []);

  ////

  ///TTS
  const loadDailyTTSUsage = () => {
    const today = new Date().toDateString();
    const savedData = localStorage.getItem(`${APP_ID}_tts_usage`);
    
    if (savedData) {
      const { date, usage } = JSON.parse(savedData);
      if (date === today) {
        return usage;
      }
    }
    
    // If it's a new day or no data exists, reset the usage
    saveDailyTTSUsage(0);
    return 0;
  };
  
  const saveDailyTTSUsage = (usage) => {
    const today = new Date().toDateString();
    const data = JSON.stringify({ date: today, usage });
    localStorage.setItem(`${APP_ID}_tts_usage`, data);
  };

  const checkAndResetDailyUsage = () => {
    const currentUsage = loadDailyTTSUsage();
    setDailyTTSUsage(currentUsage);
  };
  ////

  const [errorToast, setErrorToast] = useState({
    open: false,
    message: ''
  });

  //const [expressions, setExpressions] = useState(['neutral', 'pout', 'smile', 'smirk', 'wink', 'glare']);
  //'us-female-12' 'emma-watson'
  const playVoiceSynthesis = async (text, task = null) => {
    const cleanText = text.replace(/\*[^*]+\*/g, '').slice(0, 400);
    const characterCount = cleanText.length;
  
    if (!apiSettings.useNeetsAIKey) {
      if (dailyTTSUsage + characterCount > 5000) {
        setErrorToast({
          open: true,
          message: 'Daily TTS limit reached. Please try again tomorrow.'
        });
        return;
      }
    }
  
    setWaiting(true);
    let url;
    let params;
    let headers = {};
  
    if (apiSettings.useNeetsAIKey) {
      url = 'https://api.neets.ai/v1/tts';
      params = {
        text: cleanText,
        voice_id: apiSettings.voiceId,
        params: {
          model: 'ar-diff-50k'
        }
      };
      headers = {
        'Content-Type': 'application/json',
        'X-API-Key': apiSettings.neetsAIKey
      };
    } else {
      url = 'https://voice.fierylionite.workers.dev/';
      params = {
        text: cleanText,
        voice_id: apiSettings.voiceId
      };
      headers = {
        'Content-Type': 'application/json'
      };
    }
  
    try {
      const response = await fetch(url, {
        method: 'POST',
        headers: headers,
        body: JSON.stringify(params)
      });
  
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
  
      const blob = await response.blob();
  
      if (task)
        addChatResponse(task);
  
      setLastExpression(lexp => {
        setExpression(lexp)
        return lexp;
      })
      const objectURL = URL.createObjectURL(blob);
      const audio = new Audio(objectURL);
      console.log('Playing audio...');
  
      audio.onended = () => {
        setWaiting(false);
        URL.revokeObjectURL(objectURL);
      };
  
      audio.play();
  
      // Update daily usage only if not using custom NeetsAI key
      if (!apiSettings.useNeetsAIKey) {
        const newUsage = dailyTTSUsage + characterCount;
        setDailyTTSUsage(newUsage);
        saveDailyTTSUsage(newUsage);
      }
  
    } catch (e) {
      setWaiting(false);
      console.error('Failed to fetch voice synthesis:', e);
      setErrorToast({
        open: true,
        message: `Error playing voice synthesis: ${e.message}`
      });
    }
  };

  // Add a function to handle closing the error toast
  const handleCloseErrorToast = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }
    setErrorToast({
      open: false,
      message: ''
    });
  };

  function saveMessages(messages){
    localStorage.setItem(APP_ID+ '_messages', JSON.stringify(messages));
    localStorage.setItem(APP_ID+ '_language', language);
    
  }
  function loadMessages(){
    const savedMessages = localStorage.getItem(APP_ID+ '_messages');
    const loadLanguage = localStorage.getItem(APP_ID+ '_language');
    
    const savedProgress = localStorage.getItem(APP_ID + '_progress');
    if (savedProgress !== null) {
      setProgress(parseFloat(savedProgress));
    }

    const savedLevel = localStorage.getItem(APP_ID + '_level');
    if (savedLevel !== null) {
      setProfileIdx(parseFloat(savedLevel));
    }

    if (loadLanguage)//HARDCODED!!!!
        setLanguage(loadLanguage);

    return savedMessages ? JSON.parse(savedMessages) : [];
  }

  const scrollToBottom = () => {
    if (messagesContainerRef.current) {
      messagesContainerRef.current.scrollTop = messagesContainerRef.current.scrollHeight;
    }
  };

  function truncateMessages(messages, limit = 2000) {
    console.log("be4truncate", messages);
    let totalChars = 0;
    let startIndex = 0;

    // Find the index of the first non-system message
    while (startIndex < messages.length && messages[startIndex].role === "system") {
        startIndex++;
    }

    // Ensure we start with a user message after system messages
    if (startIndex < messages.length && messages[startIndex].role !== "user") {
        startIndex++;
    }

    // Calculate total characters and find where to start truncating
    for (let i = messages.length - 1; i >= startIndex; i--) {
        totalChars += messages[i].content.length;
        if (totalChars > limit) {
            startIndex = i;
            break;
        }
    }

    // Adjust startIndex to ensure we begin with a user message
    while (startIndex < messages.length - 1 && messages[startIndex].role !== "user") {
        startIndex++;
    }

    // Create the truncated messages array
    const truncatedMessages = [];
    for (let i = 0; i < messages.length; i++) {
        if (i < startIndex && messages[i].role === "system") {
            truncatedMessages.push(messages[i]);
        } else if (i >= startIndex) {
            truncatedMessages.push(messages[i]);
        }
    }

    console.log(truncatedMessages);
    return truncatedMessages;
}

  function truncateMessages_deleteme(messages, limit=2000) {
    console.log("be4truncate", messages)
    let totalChars = 0;
    let index = messages.length - 1;

    // Loop through messages backwards and sum up the characters
    while (index >= 0) {
        const message = messages[index];
        totalChars += message.content.length;

        // Break the loop once the total character count exceeds 2000
        if (totalChars > limit) {
            break;
        }
        index--;
    }

    // Remove all messages prior to the index where the sum exceeded 2000
    // except for system messages
    const truncatedMessages = [];
    for (let i = 0; i < messages.length; i++) {
        if (i > index || messages[i].role === "system") {
            truncatedMessages.push(messages[i]);
        }
    }
    console.log(truncatedMessages);
    return truncatedMessages;
}

  

  const setExpression = (expression) => {
    
    // Convert the expression parameter to lowercase
    const normalizedExpression = expression.toLowerCase();

    // Check if any expression in the expressions array is part of the normalizedExpression
    const foundExpression = expressions.find(exp => normalizedExpression.includes(exp));

    // If a matching expression is found, call setExpressionImage with it
    if (foundExpression) {
      setExpressionImage(foundExpression);
    }else{
      //window.alert(expression)
      setExpressionImage('neutral');
    }
  };

  useEffect(()=>{
    const msgs = loadMessages();
    if (msgs.length > 0)
      setMessages(msgs);
    checkAndResetDailyUsage();

    // Check every hour if the day has changed
    const intervalId = setInterval(checkAndResetDailyUsage, 60 * 60 * 1000);

    return () => clearInterval(intervalId);
  }, [])

  useEffect(() => {
    scrollToBottom();
  }, [messages]);

  const sendFriendlinessRequest = async (message) => {
    const systemMessage = {
      role: "system",
      content: "Analyze the sexual intensity (how horny she is) of the given message. Rate it on a scale from -50 (extremely turn off) to 50 (extremely horny,flirty). If the message is explicitly asking for sex, give 1000. Respond with only the numeric rating."
    };
    const userMessageObject = {
      role: "user",
      content: message
    };
  
    try {
      const data = await sendChatRequest([systemMessage, userMessageObject]);
      return handleFriendlinessResponse(data);
    } catch (error) {
      console.error('Error sending friendliness request:', error);
      return 0; // Default to neutral if there's an error
    }
  };
  
  const FRIENDLINESS_BONUS = 1.5;
  const handleFriendlinessResponse = (data) => {
    if (data && data.choices && data.choices.length > 0) {
      const friendlinessRating = parseInt(data.choices[0].message.content);
      console.log('Friendliness rating:', friendlinessRating);
      return friendlinessRating*FRIENDLINESS_BONUS;
    }
    return 0; // Default to neutral if we can't parse the response
  };

  const handleInputChange = (event) => {
    setInput(event.target.value);
  };

  const sanitizeAIOutput = (text) => {
    // Trim leading and trailing whitespace (including newlines)
    let sanitized = text.trim();
  
    // Remove square brackets and their contents
    sanitized = sanitized.replace(/\[.*?\]/g, '');

    // Remove encapsulating quotation marks if present
    sanitized = sanitized.replace(/^"(.*)"$/, '$1');
  
    // Remove angle brackets and their contents if both opening and closing brackets are present
    sanitized = sanitized.replace(/<.*?>/g, '');
  
    // Remove "user:" and any text after it
    const userIndex = sanitized.indexOf('user:');
    if (userIndex !== -1) {
      sanitized = sanitized.substring(0, userIndex);
    }
  
    // Remove all text after a newline
    const newlineIndex = sanitized.indexOf('\n');
    if (newlineIndex !== -1) {
      sanitized = sanitized.substring(0, newlineIndex);
    }
  
    // Trim any remaining whitespace
    sanitized = sanitized.trim();
  
    // Throw an error if the sanitized text is empty
    if (sanitized.length === 0) {
      throw new Error('Sanitized AI output is empty');
    }
  
    return sanitized;
  };
  
  const sendChatRequest = async (messages) => {
    try {
      const response = await fetch(apiSettings.apiEndpoint, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          ...(apiSettings.apiToken && { 'Authorization': `Bearer ${apiSettings.apiToken}` })
        },
        body: JSON.stringify({
          model: apiSettings.modelName,
          messages: messages,
          stream: false,
          max_tokens: apiSettings.maxTokens
        })
      });
      
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
      
      const data = await response.json();
      
      // Sanitize the AI output
      const sanitizedOutput = sanitizeAIOutput(data.choices[0].message.content);
      
      // Return the sanitized output
      return { ...data, choices: [{ ...data.choices[0], message: { ...data.choices[0].message, content: sanitizedOutput } }] };
    } catch (error) {
      console.error('Error sending chat request:', error);
      setErrorToast({
        open: true,
        message: `Error sending chat request: ${error.message}`
      });
      throw error;
    }
  };

  const sendMessage = async () => {
    if (input.trim()) {
      const newMessage = { role: "user", content: input };
      const updatedMessages = [...messages, newMessage];
      setMessages(updatedMessages);
      setInput('');
      setWaiting(true);
      setCanReroll(false);
      
      const updatedSystemMessage = {
        role:'system',
        content: language.toLowerCase() === "english" ? systemMessage.content : systemMessage.content + "Please speak in " + language + "!"
      }

      let sendMessage = [updatedSystemMessage, ...updatedMessages];
      //if (messages.length==0)
      //  sendMessage = [updatedSystemMessage, ...initMsgs, ...updatedMessages];

      try {
        const data = await sendChatRequest(truncateMessages(sendMessage));
        handleServerResponseChat(data);
      } catch (error) {
        console.error('Error in sendMessage:', error);
        setWaiting(false);
        setErrorToast({
          open: true,
          message: `Error sending message: ${error.message}`
        });
      }
    }
  };

  const rerollMessage = async () => {
    if (messages.length >= 2) {
      setWaiting(true);
      setCanReroll(false);
      
      // Remove the last AI message
      const updatedMessages = messages.slice(0, -1);
      setMessages(updatedMessages);

      const updatedSystemMessage = {
        role:'system',
        content: language.toLowerCase() === "english" ? systemMessage.content : systemMessage.content + "Please only use " + language + "!"
      }

      let sendMessage = [updatedSystemMessage, ...updatedMessages];

      try {
        const data = await sendChatRequest(truncateMessages(sendMessage));
        handleServerResponseChat(data);
      } catch (error) {
        console.error('Error in rerollMessage:', error);
        setErrorToast({
          open: true,
          message: `Error sending message: ${error.message}`
        });
        setWaiting(false);
      }
    }
  };
  
  const addChatResponse = (task) => {
    setMessages(prevMessages => { 
      const newMessages = [...prevMessages, { role: "assistant", content: task.response.response }]
      saveMessages(newMessages);
      return newMessages;
    });
    setWaiting(false);
  }

  const handleServerResponseChat = async (data) => {
    if (data && data.choices && data.choices.length > 0) {
      const aiResponse = data.choices[0].message.content;
      console.log('AI Response:', aiResponse);
      
      // Assess friendliness
      const friendlinessRating = await sendFriendlinessRequest(aiResponse);
      setProgress(p => {
        const newProgress = p + friendlinessRating;
        localStorage.setItem(APP_ID + '_progress', newProgress.toString());
        return newProgress;
      });
      setProfileIdx(idx=>{
        localStorage.setItem(APP_ID+ '_level', idx);
        return idx;
      })
      
      if (!voiceToggle)
        addChatResponse({ response: { response: aiResponse, friendliness: friendlinessRating } });
      
      sendExpressionRequest(aiResponse);
      if (voiceToggle)
        sendVoiceRequest(aiResponse);
      
      setCanReroll(true);
    }
  };

  const sendVoiceRequest = async (userMessage) => {
    playVoiceSynthesis(userMessage.replace(/\*[^*]+\*/g, '').slice(0, 400), { response: { response: userMessage } });
  };

  const sendVoiceRequest_delete_me = async (userMessage) => {
    if (userMessage.length > 300){
      const userMessageObject = {
        role: "user",
        content: 'Help me slightly shorten this dialogue. Respond with only the text, no quotation marks! "' + userMessage.replace(/\*[^*]+\*/g, '') +'"'
      };
    
      try {
        const data = await sendChatRequest([userMessageObject]);
        handleVoiceResponse(data);
      } catch (error) {
        console.error('Error sending voice request:', error);
      }
    }else{
      playVoiceSynthesis(userMessage.replace(/\*[^*]+\*/g, ''), { response: { response: userMessage } });
    }
  };


  const handleVoiceResponse = (data) => {
    if (data && data.choices && data.choices.length > 0) {
      const voiceLine = data.choices[0].message.content;
      console.log('Voice line:', voiceLine);
      playVoiceSynthesis(voiceLine, { response: { response: voiceLine } });
    }
  };


  
  const sendExpressionRequest = async (userMessage) => {
    // Check if there are more than one expression options
    if (expressions.length <= 1) {
      // If there's only one or no expression, set it directly without querying the AI
      setExpression(expressions[0] || 'neutral');
      setLastExpression(expressions[0] || 'neutral');
      setTimeout(() => { setExpression('neutral') }, 5000);
      return;
    }
  
    const systemMessage = {
      role: "system",
      content: `Determine what facial expression should be used for the user message. Pick one from the following only: ${expressions.join(", ")}. Respond with one word!`
    };
    const userMessageObject = {
      role: "user",
      content: userMessage
    };
  
    try {
      const data = await sendChatRequest([systemMessage, userMessageObject]);
      handleServerResponseExpression(data);
    } catch (error) {
      console.error('Error sending expression request:', error);
    }
  };

  const handleServerResponseExpression = (data) => {
    if (data && data.choices && data.choices.length > 0) {
      const expression = data.choices[0].message.content.toLowerCase();
      console.log('Expression analysis:', expression);
      if (!voiceToggle)
        setExpression(expression);

      setLastExpression(expression);
      setTimeout(() => { setExpression('neutral') }, 5000);
    }
  };

  const handleKeyPress = (event) => {
    if (event.key === 'Enter') {
      sendMessage();
    }
  };

  const renderMessages = () => {
    const filteredMessages = messages.filter(message => message.role !== 'system');
    const totalMessages = filteredMessages.length;
  
    return filteredMessages.reverse().map((message, index) => {
      let opacity = ((totalMessages - index) / totalMessages) * 1.2;
      opacity = Math.max(opacity, 0.35);
  
      const isLastMessage = index === 0;
  
      return (
        <Box
          key={index}
          sx={{
            margin: 1,
            padding: 1,
            borderRadius: 1,
            bgcolor: message.role === 'user' ? '#e0f7fa' : '#fff9c4',
            alignSelf: message.role === 'user' ? 'flex-end' : 'flex-start',
            width: 'fit-content',
            maxWidth: '80%',
            opacity: opacity.toFixed(2),
            boxShadow: '0px 4px 6px rgba(0,0,0,0.5)',
            position: 'relative',
            '&:hover .message-speaker': {
              display: 'block',
            },
          }}
        >
          {isLastMessage ? (
            <Typewriter
              key={`${message.content}-${index}`}
              words={[message.content]}
              typeSpeed={20}
              deleteSpeed={Infinity}
              delaySpeed={1000}
              loop={1}
              cursor={false}
            />
          ) : (
            message.content
          )}
          {voiceToggle && !waiting && message.role =='assistant' && <IconButton
            className="message-speaker"
            size="small"
            onClick={() => playVoiceSynthesis(message.content.replace(/\*[^*]+\*/g, '').slice(0, 400))}
            sx={{
              position: 'absolute',
              top: -20,
              right: 0,
              display: 'none',
              backgroundColor: 'white',
              '&:hover': {
                backgroundColor: 'lightgrey',
              },
            }}
          >
            <VolumeUpIcon fontSize="small" />
          </IconButton>}
        </Box>
      );
    });
  };
  

  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleClearConversation = () => {
    //console.log("Clear conversation");
    const newInitMsgs = [
      {role: 'assistant', content:  _.sample(startMessages)}
    ]

    setMessages([...newInitMsgs]);
    saveMessages(newInitMsgs);
    resetScene();
    handleClose();
  };
  
  const handleAutofill = async () => {
    setWaiting(true);
    
    const autofillSystemMessage = {
      role: "system",
      //content: "You are assisting in generating a user's next message in a conversation. Based on the conversation history provided, suggest a brief, natural response the user might type next. Keep it concise, contextual, and in the user's perspective."
      //content: "You stumble into Alice's dimly lit bar, the only patron on a slow night. As you lock eyes with the captivating bartender, you can't help but feel drawn to her. Your goal is to charm your way into her good graces and, hopefully, her bed. Keep your words smooth and concise, avoiding overly elaborate sentences or conversations that might scare her off."
       //content: "You are a stranger stumbling upon Alice's bar late at night. You find yourself very attracted to her and would like to spend the night together intimately. Please write in first-person dialogue, where the speaker is directly addressing another person or people. Focus on the conversational aspect, capturing the speaker's voice, emotions, and interactions with others. Avoid narrative descriptions and internal thoughts, and instead emphasize the natural flow of conversation."
      content: "You are a stranger stumbling upon the user's bar late at night. User's name is Alice, she is a bartender. As you lock eyes with her, you can't help but feel drawn to her. Your goal is to charm your way into her good graces and, hopefully, her bed. Keep your words smooth and concise, avoiding overly elaborate sentences or conversations that might scare her off. DO NOT NARRATE THE STORY! DO NOT WRITE THIRD PERSON! Only write first person dialogue."
    };


    if (language.toLowerCase() != "english")
      autofillSystemMessage.content += "Please speak in " + language + "!";

    // Get the entire conversation history
    const conversationHistory = messages;

    // Flip the roles for the AI to better understand the user's perspective
    const flippedHistory = conversationHistory.map(msg => ({
      ...msg,
      role: msg.role === 'user' ? 'assistant' : 'user'
    }));

    // Prepare the messages array for truncation
    const messagesToTruncate = [autofillSystemMessage, ...flippedHistory];

    // Truncate messages to manage token count
    const truncatedMessages = truncateMessages(messagesToTruncate, 1500); // Adjust the limit as needed

    try {
      const data = await sendChatRequest(truncatedMessages);
      if (data && data.choices && data.choices.length > 0) {
        //removing any encapsulating quotation marks
        const suggestion = data.choices[0].message.content.replace(/^"(.*)"$/, '$1');
        
        setInput(suggestion);
      }
    } catch (error) {
      console.error('Error in handleAutofill:', error);
      setErrorToast({
        open: true,
        message: `Error getting autofill suggestion: ${error.message}`
      });
    } finally {
      setWaiting(false);
    }
  };

  const handleOpenDiscord = () => {
    window.open('https://discord.com/invite/HQjVYzRUsE', '_blank');
    handleClose();
  };

  return (
    <>
    {/* New Floating Panel */}
    <Box sx={{
        backgroundColor: 'rgba(0, 0, 0, 0.5)', // Semi-transparent background
        position: 'absolute',
        bottom: 2, // Anchored to the bottom of the viewport
        right: '50%', // Positioned at 50% from the left
        display: 'flex',
        alignItems: 'center',
        backgroundColor: 'rgba(178, 229, 252, 0.7)', // Semi-transparent background
        backdropFilter: isMobile ? 'none' : 'blur(5px)', // Apply blur effect
        justifyContent: 'flex-start', // Aligns the button to the left
        padding: '2px' // Padding around the content
      }}>
        <PopoverMsg anchorElementId='voiceToggle' content='Enable voice here'/>
        
        <VoiceToggle setVoiceToggle={setVoiceToggle} />

        {true && <AudioPlayer url="windybalcony.mp3" />}
          <TextField
            autoComplete='off'
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <LanguageIcon />
                </InputAdornment>
              ),
            }}
          label="Language"
          variant="outlined"
          value={language}
          size="small"
          onChange={(e) => setLanguage(e.target.value)}
         // Adjust styling as needed //(1-tokens/TOKEN_LIMIT)*100 < 100)
        />
        <Tooltip title="Menu">
        <IconButton
          aria-label="menu"
          aria-controls="menu-appbar"
          aria-haspopup="true"
          onClick={handleClick}
          color="inherit"
          size={isMobile?"small":"large"}
        >
          <MenuIcon fontSize='inherit' />
        </IconButton>
        </Tooltip>
        <Menu
        id="menu-appbar"
        anchorEl={anchorEl}
        anchorOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }}
        keepMounted
        transformOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }}
        open={open}
        onClose={handleClose}
      >
        <MenuItem onClick={handleOpenDiscord}>
          <ListItemIcon>
            <DiscordIcon fontSize="small" />
          </ListItemIcon>
          <ListItemText>Discord</ListItemText>
        </MenuItem>
        <MenuItem onClick={handleOpenApiDialog}>
          <ListItemIcon>
            <SettingsIcon fontSize="small" />
          </ListItemIcon>
          <ListItemText>API Endpoint</ListItemText>
        </MenuItem>
        <MenuItem onClick={handleClearConversation}>
          <ListItemIcon>
            <DeleteSweepIcon fontSize="small" />
          </ListItemIcon>
          <ListItemText>Clear conversation</ListItemText>
        </MenuItem>

      </Menu>
        <ApiSettingsDialog 
          open={openApiDialog}
          onClose={handleCloseApiDialog}
          onSave={handleSaveApiSettings}
          initialSettings={apiSettings}
        />
        <Tooltip title="Resend message">
          <IconButton 
            aria-label="reroll" 
            onClick={rerollMessage} 
            size={isMobile?"small":"large"}
            disabled={waiting || !canReroll}
          >
            <ReplayIcon fontSize="inherit" />
          </IconButton>
          </Tooltip>
          <Tooltip title="Autofill">
          <IconButton 
            aria-label="autofill" 
            onClick={handleAutofill} 
            size={isMobile?"small":"large"}
            disabled={waiting || messages.length==0}
          >
            <EditIcon fontSize="inherit" />
          </IconButton>
        </Tooltip>
      </Box>

      <Box sx={{
        width: "40%",
        height: '100vh',
        bottom:2,
        backgroundColor: 'transparent',
        position: 'absolute',
        left: '50%',
        transform: 'translateX(0%)',
        overflow: 'hidden',
        display: 'flex',
        flexDirection: 'column'
      }}>
        <Box
          ref={messagesContainerRef}
          className='hidescroll'
          sx={{
            flexGrow: 1,
            overflow:'auto',
            padding: 2,
            display: 'flex',
            flexDirection: 'column-reverse',
          }}
        >
          {renderMessages()}
        </Box>
        <Box sx={{
          width: '100%',
          padding: 0,
          display: 'flex',
          alignItems: 'center',
          backgroundColor: 'rgba(178, 229, 252, 0.7)',
          backdropFilter: isMobile ? 'none' : 'blur(5px)'
        }}>
          <TextField
            fullWidth
            multiline
            disabled={waiting}
            size={isMobile?"small":"medium"}
            color="primary"
            autoComplete='off'
            variant="outlined"
            placeholder="Type a message..."
            value={input}
            onChange={handleInputChange}
            onKeyPress={handleKeyPress}
            sx={{ marginRight: 0}}
            InputProps={{
              endAdornment: (
                <InputAdornment position="end">
                  {waiting && <CircularProgress size={24} />}
                </InputAdornment>
              ),
              startAdornment: (
                <InputAdornment position="end">
                  {waiting && <CircularProgress size={24} />}
                </InputAdornment>
              )
            }}
          />
          <Tooltip title="Send message">
          <IconButton 
            aria-label="send" 
            onClick={sendMessage} 
            size={isMobile?"small":"large"}
            disabled={waiting}
          >
            <SendIcon fontSize="inherit" />
          </IconButton>
          </Tooltip>
          
        </Box>
      </Box>
      <Snackbar 
        open={errorToast.open} 
        autoHideDuration={6000} 
        onClose={handleCloseErrorToast}
        anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
      >
        <Alert onClose={handleCloseErrorToast} severity="error" sx={{ width: '100%' }}>
          {errorToast.message}
        </Alert>
      </Snackbar>
    </>
  );
};

export default ChatPanel;
